import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { CreateHookFromTemplatePayload } from '@rossum/api-client/hooks';
import { api } from '../../../../../lib/apiClient';
import {
  throwError,
  throwInfo,
} from '../../../../../redux/modules/messages/actions';
import { QUERY_KEY_HOOKS } from '../../../hooks/useHooks';

type HookMutationVariables = {
  payload: CreateHookFromTemplatePayload;
};

export const useCreateHookFromTemplate = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ payload }: HookMutationVariables) =>
      api.request(endpoints.hooks.createFromTemplate(payload)),

    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY_HOOKS]);
      dispatch(throwInfo('extensionCreated'));
    },

    onError: () => {
      dispatch(throwError('extensionUpdateFailed'));
    },
  });
};
